<template>
  <section>
    <!-- <v-layout v-if="tipo_usuario !== 'usuario_externo'">
      <finalizar-ciudadania></finalizar-ciudadania>
    </v-layout> -->
    <v-layout v-if="tipo_usuario !== 'usuario_externo'">
      <finalizar-ciudadania-sin-archivo></finalizar-ciudadania-sin-archivo>
    </v-layout>
    <v-layout v-if="tipo_usuario === 'usuario_externo'">
      <finalizar-normal></finalizar-normal>
    </v-layout>
  </section>
</template>
<script>
// import FinalizarCiudadania from '@/components/declaracion/finalizarCiudadania';
import FinalizarCiudadaniaSinArchivo from '@/components/declaracion/finalizarCiudadaniaSinArchivo';
import FinalizarNormal from '@/components/declaracion/finalizarNormal';
export default {
  created () {
    let token = this.$util.parseJwt(this.$storage.get('token'));
    this.tipo_usuario = token.tipo;
  },
  components: {
    // FinalizarCiudadania,
    FinalizarCiudadaniaSinArchivo,
    FinalizarNormal
  },
  data: () => ({
    tipo_usuario: ''
  })
};
</script>


// WEBPACK FOOTER //
// src/components/declaracion/finalizar.vue